import Model from "./Model.js";

/**
 * Value holding class to gather all data to configure
 * period reports.
 *
 * @param {string} periodReportChecklistTemplateId - ID of the period report ChecklistTemplate
 * @param {boolean} isPeriodReportChecklistSequential - When true, the checklist must be completed
 *   sequentially
 */
export default class PeriodReportSettings extends Model {
	constructor({
		periodReportChecklistTemplateId,
		isPeriodReportChecklistSequential = true,
	} = {}) {
		super(...arguments);
		this._periodReportChecklistTemplateId = periodReportChecklistTemplateId;

		this._isPeriodReportChecklistSequential =
			isPeriodReportChecklistSequential;
	}

	getPeriodReportChecklistTemplateId() {
		return this._periodReportChecklistTemplateId;
	}

	isPeriodReportChecklistSequential() {
		return this._isPeriodReportChecklistSequential;
	}

	setPeriodReportChecklistSequentiality(boolean) {
		this._isPeriodReportChecklistSequential = boolean;
	}
}
